import { Toaster as Sonner, toast as sonnerToast } from "sonner"
import { CheckCircle2, XCircle, AlertTriangle, Info, Loader2, WifiOff } from "lucide-react"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      expand={true}
      richColors={true}
      closeButton={true}
      duration={4000}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-gray-900 group-[.toaster]:border group-[.toaster]:shadow-xl group-[.toaster]:rounded-xl group-[.toaster]:p-4",
          description: "group-[.toast]:text-gray-600 group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-indigo-950 group-[.toast]:text-white group-[.toast]:rounded-lg group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-sm group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-gray-100 group-[.toast]:text-gray-700 group-[.toast]:rounded-lg group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-sm",
          success: "group-[.toaster]:border-emerald-200 group-[.toaster]:bg-emerald-50",
          error: "group-[.toaster]:border-red-200 group-[.toaster]:bg-red-50",
          warning: "group-[.toaster]:border-amber-200 group-[.toaster]:bg-amber-50",
          info: "group-[.toaster]:border-blue-200 group-[.toaster]:bg-blue-50",
        },
      }}
      {...props} 
    />
  );
}

// Custom toast functions with icons
const toast = {
  // Success toast with checkmark icon
  success: (message, options = {}) => {
    return sonnerToast.success(message, {
      icon: <CheckCircle2 className="w-5 h-5 text-emerald-600" />,
      style: {
        background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
        border: '1px solid #a7f3d0',
      },
      ...options,
    });
  },

  // Error toast with X icon
  error: (message, options = {}) => {
    return sonnerToast.error(message, {
      icon: <XCircle className="w-5 h-5 text-red-600" />,
      style: {
        background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
        border: '1px solid #fecaca',
      },
      duration: 5000,
      ...options,
    });
  },

  // Warning toast
  warning: (message, options = {}) => {
    return sonnerToast.warning(message, {
      icon: <AlertTriangle className="w-5 h-5 text-amber-600" />,
      style: {
        background: 'linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)',
        border: '1px solid #fde68a',
      },
      ...options,
    });
  },

  // Info toast
  info: (message, options = {}) => {
    return sonnerToast.info(message, {
      icon: <Info className="w-5 h-5 text-blue-600" />,
      style: {
        background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
        border: '1px solid #bfdbfe',
      },
      ...options,
    });
  },

  // Loading toast
  loading: (message, options = {}) => {
    return sonnerToast.loading(message, {
      icon: <Loader2 className="w-5 h-5 text-indigo-600 animate-spin" />,
      style: {
        background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
        border: '1px solid #c4b5fd',
      },
      ...options,
    });
  },

  // Offline toast - special for offline scenarios
  offline: (message, options = {}) => {
    return sonnerToast.warning(message, {
      icon: <WifiOff className="w-5 h-5 text-gray-600" />,
      style: {
        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
        border: '1px solid #d1d5db',
      },
      duration: 6000,
      ...options,
    });
  },

  // Promise toast for async operations
  promise: sonnerToast.promise,

  // Dismiss toast
  dismiss: sonnerToast.dismiss,

  // Custom toast
  custom: sonnerToast,
};

export { Toaster, toast }
